module.exports = __webpack_public_path__ + "img/imoveis.9df3f471.svg";